import { memo, useState, useEffect } from 'react';
import { pm2ConfigStore } from '@pm2/store';
import { getStatusForProduct } from '@pm2/user-area';
import { userIdentityManager, useUserIdentityState } from '@provider/user-identity';
import { Tooltip, KeyIcon } from '@ui/kit';
import { Snackbar } from './Snackbar/Snackbar.js';
import { toolButtonCls } from './root.tools.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function LogInNonMemoized() {
  const loginDisabled = pm2ConfigStore.useSelector(state => state.config.settings.loginDisabled);
  const uniqueId = pm2ConfigStore.useSelector(state => state.config.uniqueId);
  const urgentNotifications = useUrgentNotifications(uniqueId);
  if (loginDisabled) {
    // disable login tool if it's been disabled globally for the portal...
    // however, we still need to be able to display notifications if necessary
    return /*#__PURE__*/jsx(Snackbar, {
      notifications: urgentNotifications
    });
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Tooltip, {
      placement: "bottom",
      body: "Log ind",
      ariaType: "label",
      offsetPx: 0,
      children: ref => /*#__PURE__*/jsx("button", {
        ref: ref,
        className: toolButtonCls,
        onClick: userIdentityManager.requestLogin,
        children: /*#__PURE__*/jsx(KeyIcon, {
          height: 24
        })
      })
    }), /*#__PURE__*/jsx(Snackbar, {
      notifications: urgentNotifications
    })]
  });
}
const LogIn = /*#__PURE__*/memo(LogInNonMemoized);

/**
 * When the user isn't logged in, then the user-area cannot be rendered which
 * means that urgent messages won't be fetched and displayed.
 *
 * Therefore this custom integration of custom messages is used while the user
 * isn't logged in so that urgent notifications can be displayed in all cases.
 */
function useUrgentNotifications(productId) {
  const user = useUserIdentityState(state => state.user);
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    // Do not fetch notifications before we have resolved whether or not a user
    // is logged in.
    if (user === undefined) {
      return;
    }
    const fetchNotifications = async () => {
      const notifications = await getStatusForProduct(productId);
      const urgentNotifications = notifications.filter(it => it.urgent);
      setNotifications(urgentNotifications);
    };
    fetchNotifications().catch(err => console.error(`Failed to fetch urgent notifications.`, err));
  }, [productId, user]);
  return notifications;
}

export { LogIn };
//# sourceMappingURL=tool.log-in.js.map
